import { FC } from "react";
import orderListingTableRouteFactory from "../../../../common/table/route/order-listing-table-route.factory";

type OrderFinishedListingTableRouteProps = {
  addresses: (string | string[])[];
};

const OrderFinishedListingTableRouteComponent: FC<
  OrderFinishedListingTableRouteProps
> = (props) => {
  const addressesString = orderListingTableRouteFactory.createRouteString(
    props.addresses
  );

  return (
    <div
      title={props.addresses.join("\r")}
      className="order_finished_listing_route"
    >
      {addressesString}
    </div>
  );
};

export default OrderFinishedListingTableRouteComponent;
